<template>
  <b-navbar-nav class="nav">
    <b-nav-item
      class="mt-50"
      v-for="(bookmark, index) in bookmarks"
      :id="`bookmark-${index}`"
      :key="index"
      :to="bookmark.route"
    >
      <feather-icon :icon="bookmark.icon" size="25" />
      <b-tooltip
        triggers="hover"
        :target="`bookmark-${index}`"
        :title="bookmark.title"
        :delay="{ show: 100, hide: 50 }"
      />
    </b-nav-item>
    
    <b-nav-item
      v-if="env_name ? true : false"
      id="clear-cache"
      class="mt-50"
      @click="clearCache()"
    >
      <feather-icon icon="ServerIcon" size="25" />
      <b-tooltip
        triggers="hover"
        :target="`clear-cache`"
        title="Limpar Cache"
        :delay="{ show: 100, hide: 50 }"
      />
    </b-nav-item>

    <b-alert class="ml-5 m-0" variant="warning" :show="env_name ? true : false">
      <div class="alert-body">
        <span>
          <strong>{{ env_name }}</strong>
        </span>
      </div>
    </b-alert>
  </b-navbar-nav>
</template>

<script>
import {
  BNavbarNav,
  BNavItem,
  BNavItemDropdown,
  BFormInput,
  BDropdownItem,
  BAlert,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import useAutoSuggest from "@core/components/app-auto-suggest/useAutoSuggest";
import { ref, watch } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import searchAndBookmarkData from "../search-and-bookmark-data";
import _jobsService from "@/services/jobs-service";

export default {
  data() {
    return {
      env_name: process.env.VUE_APP_ENVIROMENT,
    };
  },
  components: {
    BNavbarNav,
    BNavItem,
    BNavItemDropdown,
    BFormInput,
    VuePerfectScrollbar,
    BDropdownItem,
    BAlert,
  },
  setup() {
    const searchAndBookmarkDataPages = ref(searchAndBookmarkData.pages);

    let bookIcons = ref(
      searchAndBookmarkData.pages.data.filter((page) => page.isBookmarked)
    );
    if (bookIcons.value && bookIcons.value.length > 0) {
      bookIcons.value.forEach((_book) => {
        _book.visible = true;

        if (_book.route.name === "pedagogic-calendar") {
          const userData = JSON.parse(localStorage.getItem("userData"));

          if (userData && userData.roles) {
            _book.visible = userData.roles.some(
              (s) =>
                s === "permission.calendar.teacher.view" ||
                s === "permission.appointment.view"
            );
          }
        }
      });
    }

    const bookmarks = bookIcons.value.filter((f) => f.visible);

    const currentSelected = ref(-1);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    };

    const { searchQuery, resetsearchQuery, filteredData } = useAutoSuggest({
      data: { pages: searchAndBookmarkDataPages.value },
      searchLimit: 6,
    });

    watch(searchQuery, (val) => {
      store.commit("app/TOGGLE_OVERLAY", Boolean(val));
    });

    watch(filteredData, (val) => {
      currentSelected.value = val.pages && !val.pages.length ? -1 : 0;
    });

    const suggestionSelected = () => {
      const suggestion = filteredData.value.pages[currentSelected.value];
      router.push(suggestion.route).catch(() => {});
      resetsearchQuery();
    };

    const toggleBookmarked = (item) => {
      // Find Index of item/page in bookmarks' array
      const pageIndexInBookmarks = bookmarks.value.findIndex(
        (i) => i.route === item.route
      );

      // If index is > -1 => Item is bookmarked => Remove item from bookmarks array using index
      // Else => Item is not bookmarked => Add item to bookmarks' array
      if (pageIndexInBookmarks > -1) {
        bookmarks.value[pageIndexInBookmarks].isBookmarked = false;
        bookmarks.value.splice(pageIndexInBookmarks, 1);
      } else {
        bookmarks.value.push(item);
        bookmarks.value[bookmarks.value.length - 1].isBookmarked = true;
      }
    };

    return {
      bookmarks,
      perfectScrollbarSettings,
      currentSelected,
      suggestionSelected,
      toggleBookmarked,

      // AutoSuggest
      searchQuery,
      resetsearchQuery,
      filteredData,
    };
  },

  methods: {
    clearCache() {
      this.isloading = true;
      _jobsService
        .clearCache()
        .then((res) => {
          this.$utils.toast("SUCESSO", "Cache Limpo");
          window.location.reload()
        })
        .catch((error) => this.$utils.toastError("Notificação", error))
        .finally(() => {
          this.isloading = false;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/bootstrap-extended/include";

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
p {
  margin: 0;
}

.nav-bookmar-content-overlay {
  position: fixed;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.7s;
  transition: all 0.7s;
  z-index: -1;

  &:not(.show) {
    pointer-events: none;
  }

  &.show {
    cursor: pointer;
    z-index: 10;
    opacity: 1;
  }
}
</style>
